import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

export const NoMatch = () => {
    const location = useLocation();

    return (
        <div className="flex flex-wrap w-full mt-[120px] justify-center">
            <div className="md:grow-0 md:basis-[75%] md:max-w-[75%]">
                <Box textAlign="center" component="h1" color="#fff">
                    Ресурс по адресу '{location.pathname}' не найден
                </Box>
            </div>
        </div>
    );
};
